import React from "react";
import {
  IconButton,
  Card,
  CardHeader,
  LinearProgress
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import AddIcon from "@material-ui/icons/Add";
import actionsTopButtonStyles from "../../../../../../components/App/customMaterialStyles";


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: "0.07em",
    borderRadius: "0",    
    "&:first-child": {
      borderRadius: "5px 5px 0 0"
    },    
    
    "& .MuiCardHeader-root": {
      padding: "13px 25px"
    },
    "& .MuiCardHeader-title": {
      fontSize: "1.2rem",
      fontWeight: "500",
      letterSpacing: "0.7px"
    },
    "& .MuiCardHeader-subheader": {
      fontSize: "0.8rem",
      letterSpacing: "0.7px"
    }
  },
  collapse: {
    borderTop: "1px solid"
  },
  lastChild: {
    borderRadius: "50px 50px 0 0",
    color: "blue"
  }  
}));

function UserSelectableItem(props) {
  const { loading = false, onAddUser, onRemoveUser, isSelected = false, action, isLoadingSubmit } = props;    
  const { first_name, last_name, is_active, email } = props.data || {};

  const classes = useStyles();
  const actionsTopButtonStylesClasses = actionsTopButtonStyles();

  const handleAddUser = () => {    
    const isSeletedItem = !isSelected;
    // setIsSelectedItem(isSeleted);    
    if(isSeletedItem){
      onAddUser(props.data);
    }else{
      onRemoveUser(props.data);
    }
  }

  const getUserInformation = () => {    
    const tagEmail = email ? `${email} | ` : '';
    const tagEnabled = `Enabled: ${is_active ? 'True' : 'False'}`;
    return `${tagEmail}${tagEnabled}`;
  }

  const buttonsBar = (
    <React.Fragment >
      {action === 'Assign' &&(
        <IconButton 
          aria-label="edit-course" 
          className={clsx(actionsTopButtonStylesClasses.actionsTopButtons, {
            [actionsTopButtonStylesClasses.actionsTopButtonsSelected]: isSelected
          }) } 
          onClick={handleAddUser}>
          <AddIcon />
        </IconButton>
      )}

      {action === 'View' &&(
        <IconButton aria-label="delete-course" 
        className={clsx(actionsTopButtonStylesClasses.actionsTopButtons, {
          [actionsTopButtonStylesClasses.actionsTopButtonsSelected]: isSelected
        }) } 
        onClick={handleAddUser}>
          <DeleteForeverOutlinedIcon />
        </IconButton>
      )}
    </React.Fragment>
  );

  return (
    <Card className={classes.root}>
      {/* Loading */}
      {isLoadingSubmit && <LinearProgress />}   
      
      {/* Course header */}
      <CardHeader
        action={
          loading ?
            <Skeleton
              variant="circle"
              width={50}
              height={50}
              style={{ marginBottom: 0 }}
            />
            :
            buttonsBar
        }        
        title={
          loading ? (
            <Skeleton
              variant="rect"
              width={180}
              height={20}
              style={{ marginBottom: 6 }}
            />
          ) : (
            `${first_name} ${last_name}`
          )
        }
        subheader={
          loading ? (
            <Skeleton variant="rect" width={210} height={10} />            
          ) : (
            getUserInformation()
          )
        }
      />        
    </Card>
  );
}

export default UserSelectableItem;
